import axios from "axios";

const user = JSON.parse(localStorage.getItem("user"));
export const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${user?.token}`,
}
export const baseUrl = process.env.REACT_APP_APIURL


export async function fetchData(endpoint, params = {}) {
    const response = await axios.get(`${baseUrl}${endpoint}`, {
      headers,
      params,
    });
    return response.data;
  }